import { Injectable } from '@angular/core';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { APIGatewayService } from '../gateway/APIGateway.service';
import { BaseEntitiesResponse, DataEditorView } from '@m4u-angular/base/entities/BaseEntities';
import { Observable } from 'rxjs';

@Injectable()
export class DataEditorEndpoint extends BaseEndpoint {
    //Constructor
    constructor(api: APIGatewayService) {
        super('DataEditor', api);
    }

    public ListViews(): Observable<BaseEntitiesResponse<DataEditorView>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'ListViews');
    }

    public CheckPerformance(views: any) {
        return this.api.ExecutePostAction(this.ControllerName, 'CheckPerformance', views);
    }

    public CheckValidity(views: any) {
        return this.api.ExecutePostAction(this.ControllerName, 'CheckValidity', views);
    }
}